
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 0a30 30 0 1030 30A30 30 0 0030 0zm17.31 17L30 32 12.69 17h34.62zM12 18.62l12.69 11L12 40.54V18.62zM12.69 42l12.64-11L30 34.72 34.6 31l12.71 11H12.69zM48 40.54l-12.69-11L48 18.62v21.92z"}})])
          )
        }
      }
    